import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  freeTextSubHeader: {
    description: 'filterOptions.freeTextSubHeader',
    defaultMessage: '(Include ; as a separator)',
    id: 'njH1CY',
  },
});
